import { apiMethodTypes } from '../constants/apiMethodTypes'
import { toCamelCase } from '../store/fixApiCasing'
import { store } from '../store/configureStore';
import { actions } from '../store/error'

// tslint:disable-next-line:no-any
const buildRequest = (url: string, method: apiMethodTypes, body?: any): Request => {
    const headers = new Headers()
    body = body ? JSON.stringify(body) : null
    
    if (body) {
        headers.append('Content-Type', 'application/json')
    }

    const isAutomation = window.sessionStorage.getItem('automation')
    if (isAutomation) {
        headers.append('IsAutomation', isAutomation)
    }
    
    return new Request(url, {
        body,
        headers,
        method,
        credentials: 'include',
        mode: 'cors',
    })
}

const makeApiCall = async <T>(request: Request, isHtmlRequest = false): Promise<T> => {
    const response = await fetch(request)
    if (!response.ok) {
        const errorText = await response.text()
        store.dispatch(actions.throwError(response, errorText));
        return null;
    }
    return (response.status === 200 ? isHtmlRequest ? response.text() : response.json() : {}) as Promise<T>
}

const get = async<T>(url: string, isHtmlRequest = false): Promise<T> => {
    const request = buildRequest(url, apiMethodTypes.get)
    const response = await makeApiCall<T>(request, isHtmlRequest)
    return response !== null ? toCamelCase(response) : makeError(request, url, 'get')
}

// tslint:disable-next-line:no-any
const post = async<T>(url: string, body: any): Promise<T> => {
    const request = buildRequest(url, apiMethodTypes.post, body)
    const response = await makeApiCall<T>(request)
    return response !== null ? toCamelCase(response) : makeError(body, url, 'post')
}

const makeError = (body: any, url: string, type: string) => {
    const errorText = 'There was a problem with the API call. Please try again, or let IT know.'
        store.dispatch(actions.throwError({body, bodyUsed: body, url, type, ok: false, redirected:false, status: 500, statusText: 'error', headers: {}}, errorText));
        return null;
}

export const apiClient = { get, post }